import React from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AllMenuHeader from "../Header/AllMenuHeader/AllMenuHeader";
import AllCuisineBreadcrumbs from "./AllCuisineBreadcrumbs";
import { TopCuisine } from "./TopCuisine";
import { AllCuisineCards } from "./AllCuisineCards";
import DiscountFooterSection from "../DiscountFooterSection/DiscountFooterSection";
import Footer from "../Footer/Footer";

export default function AllCuisine() {
  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <Box>
        <AllMenuHeader />
      </Box>

      <Box sx={{ margin: "20px" }}>
        <Box sx={{ mt: "24px" }}>
          <Box sx={{ margin: "10px" }}>
            <AllCuisineBreadcrumbs />
          </Box>
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: { lg: "56px", md: "56px", sm: "46px", xs: "40px" },
              fontWeight: "600",
            }}
          >
            Explore by cuisines
          </Typography>
        </Box>

        <Box mt="32px">
          <TopCuisine />
        </Box>

        <Box mt="80px">
          <AllCuisineCards />
        </Box>

        <Box sx={{ mt: "80px" }}>
          <DiscountFooterSection />
        </Box>
      </Box>

      <Box sx={{ mt: "100px" }}>
        <Footer />
      </Box>
    </Box>
    
  );
}
